/*
This is a newer, more general-purpose breadcrumbs component that works
anywhere. See GoodreadsBreadcrumbs component for one that expects to be used
as part of a react-router setup.

In general, page breadcrumbs should include the current page as a non-link
element: https://www.nngroup.com/articles/breadcrumbs/
*/
import DotSeparatedElements from "./dot_separated_elements";
import { Component, PropTypes } from "react";
import { forEach } from "lodash";

class Breadcrumbs extends Component {

  static renderSeparator() {
    return <span className="gr-caret
                            gr-caret--right
                            gr-caret--small
                            u-marginLeftXSmall
                            u-marginRightXSmall
                            u-inlineBlock"
    />;
  }

  getElements() {
    const elements = [];
    forEach(this.props.pageLinks, (value) => {
      if (typeof value.url !== "undefined") {
        elements.push(<a className="gr-hyperlink" href={value.url}>{value.text}</a>);
      } else {
        elements.push(<span className="u-defaultType">{value.text}</span>);
      }
    });
    return elements;
  }

  render() {
    return (
      <DotSeparatedElements
        separator={Breadcrumbs.renderSeparator()}
        elements={this.getElements()}
      />
    );
  }
}

Breadcrumbs.propTypes = {
  pageLinks: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    url: PropTypes.string,
  })).isRequired,
};

export default Breadcrumbs;
